import React from 'react';

import { Box, Chip, Paper, Stack, Typography } from '@mui/material';

import type { AiCodeProposal } from '~/services/PromoVoucherAiService';

function formatValue(value: unknown): string {
  return value === undefined ? 'Not set' : JSON.stringify(value, null, 2);
}

export default function AiWorkflowChanges({ changes }: { changes: AiCodeProposal['changes'] }) {
  return (
    <Stack spacing={2} aria-label="Fields set by AI">
      {changes.map(({ field, before, after }) => (
        <Paper key={field} variant="outlined" sx={{ p: 2, borderColor: 'info.main' }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
            <Typography variant="subtitle2" sx={{ overflowWrap: 'anywhere' }}>
              {field}
            </Typography>
            <Chip
              size="small"
              color="info"
              variant="outlined"
              label={after === undefined ? 'Removed by AI' : before === undefined ? 'Set by AI' : 'Changed by AI'}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            {[
              { label: 'Before', value: before },
              { label: 'After', value: after },
            ].map(({ label, value }) => (
              <Box key={label} sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Box
                  component="pre"
                  sx={{
                    m: 0,
                    p: 1,
                    bgcolor: label === 'After' ? 'action.selected' : 'action.hover',
                    borderRadius: 1,
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'anywhere',
                    maxHeight: 280,
                    overflow: 'auto',
                    typography: 'body2',
                  }}
                >
                  {formatValue(value)}
                </Box>
              </Box>
            ))}
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
}
